import { useWorkflows } from "@/api/workflow-hooks";
import { Button } from "@/components/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/tabs";
import { isDev } from "@/lib/utils";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

export type PageState = "extraction" | "rules" | "actions" | "deployment";

const Header = () => {
  const [jwt, setJwt] = useState("");
  const { data: workflows } = useWorkflows();
  const params = useParams();
  const [id, path, subId] = params["*"]?.split("/") || [];
  const navigate = useNavigate();

  const workflow = workflows?.items.find((w) => w.id === id);

  useEffect(() => {
    if (isDev()) {
      const storedJwt = Cookies.get("stytch_session_jwt") || "";
      if (storedJwt) {
        setJwt(storedJwt);
      }
    }
  }, []);

  const copyJwt = () => {
    navigator.clipboard.writeText(jwt);
    alert("JWT copied to clipboard!");
  };

  return (
    <header className="sticky top-0 flex items-center justify-between h-16 px-4 border-b shrink-0 md:px-6 z-50 bg-white">
      <nav className="flex items-center flex-1 text-base font-medium">
        <Link to="/">
          <img src="/ryze.png" className="w-[90px] h-[30px] mr-4" alt="Ryze" />
        </Link>
        {workflow && (
          <div className="flex items-center">
            <a href={"/projects"} className={"px-3 py-2"}>
              {workflow.name}
            </a>
          </div>
        )}
        {!id && (
          <div className="flex items-center">
            <a href={"/"} className={"block px-3 py-2"}>
              Inbox
            </a>
            <div className="w-px h-4 bg-gray-300 mx-2" />
            <a href={"/projects"} className={"block px-3 py-2 font-bold"}>
              Projects
            </a>
          </div>
        )}
        {!!id && (
          <Tabs
            value={path}
            onValueChange={(value) => {
              navigate(`/projects/${id}/${value}`);
            }}
            className="mx-auto"
          >
            <TabsList>
              <TabsTrigger value="extraction">Extraction</TabsTrigger>
              <TabsTrigger value="rules">Rules</TabsTrigger>
              <TabsTrigger value="actions">Actions</TabsTrigger>
              <TabsTrigger value="deployment">Deployment</TabsTrigger>
            </TabsList>
          </Tabs>
        )}
      </nav>
      <div className="flex items-center gap-2">
        {import.meta.env.VITE_ENV === "development" && (
          <Button
            type="button"
            onClick={() => {
              navigate(`/workflows/${id}`);
            }}
          >
            DAG
          </Button>
        )}
        {import.meta.env.VITE_ENV === "development" && jwt && (
          <button
            type="button"
            onClick={copyJwt}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                copyJwt();
              }
            }}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Copy JWT
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
